export default __webpack_public_path__ + "static/media/check.7d296a95.svg";